import { SchoolDataForm } from 'types/dacum/schoolManagement';
import { create } from 'zustand';

type Mode = 'add' | 'edit' | 'view';

// Extended form data to include backward compatibility fields
interface ExtendedSchoolDataForm extends SchoolDataForm {
  jobFamily?: string[];
  jobFamilies?: {
    jobFamilyID: string;
    jobFamilyName: string;
  }[];
  note?: string;
  businessUnit?: string;
  msSchoolCompetencyManagementID?: string;
}

interface SchoolManagementState {
  formData: ExtendedSchoolDataForm;
  mode: Mode;
  setFormData: (_data: Partial<ExtendedSchoolDataForm>) => void;
  setMode: (_data: Mode) => void;
  reset: () => void;
}

export const useSchoolManagementStore = create<SchoolManagementState>((set) => ({
  formData: {
    description: '',
    jobFamily: [], // Keep this for backward compatibility
    note: '', // Keep this for backward compatibility
    notes: '',
    schoolName: '',
    businessUnit: '', // Keep this for backward compatibility
    businessUnitID: '',
    msSchoolCompetencyManagementID: '',
    jobFamilyGroupID: '',
    listJobFamily: []
  },
  mode: 'add',
  setFormData: (data) => {
    if (data?.jobFamilies && data?.jobFamilies.length > 0) {
      data.listJobFamily = data.jobFamilies.map((item) => item.jobFamilyID);
    }
    set((state) => ({
      formData: { ...state.formData, ...data }
    }));
  },
  setMode: (data) => set(() => ({ mode: data })),
  reset: () =>
    set({
      formData: {
        description: '',
        jobFamily: [], // Keep this for backward compatibility
        note: '', // Keep this for backward compatibility
        notes: '',
        schoolName: '',
        businessUnit: '', // Keep this for backward compatibility
        businessUnitID: '',
        msSchoolCompetencyManagementID: '',
        jobFamilyGroupID: '',
        listJobFamily: []
      },
      mode: 'add'
    })
}));
